import React, { useState } from "react";
import { baixarAnexoDia } from "../../attendance-sheet.service";
import { toast } from "react-toastify";

interface FileAnexoProps {
  folhaId: string;
  dia: number;
  cpfUsuario?: string;
  cpfEstagiario?: string;
  cpfResponsavel?: string;
  /** Upload local pendente (data URL / base64). */
  anexo?: string | null;
  temAnexo?: boolean;
  nomeArquivo?: string | null;
  onChange: (anexo: string | null | undefined, nomeArquivo?: string | null) => void;
}

export const FileAnexo: React.FC<FileAnexoProps> = ({
  folhaId,
  dia,
  cpfUsuario,
  cpfEstagiario,
  cpfResponsavel,
  anexo,
  temAnexo,
  nomeArquivo,
  onChange,
}) => {
  const [baixando, setBaixando] = useState(false);
  const podeAnexar = cpfUsuario === cpfEstagiario || cpfUsuario === cpfResponsavel;
  const removidoLocalmente = anexo === null;
  const possuiAnexo = !removidoLocalmente && (Boolean(anexo) || Boolean(temAnexo));

  const abrirPDFLocal = (base64: string) => {
    if (base64.startsWith("data:")) {
      window.open(base64, "_blank");
      return;
    }
    const byteCharacters = atob(base64);
    const byteArray = Uint8Array.from(byteCharacters, (c) => c.charCodeAt(0));
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const abrirPDF = async () => {
    if (anexo) {
      abrirPDFLocal(anexo);
      return;
    }
    if (!temAnexo) return;

    setBaixando(true);
    try {
      const blob = await baixarAnexoDia(folhaId, dia);
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      toast.error(String(error));
    } finally {
      setBaixando(false);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      onChange(reader.result as string, file.name);
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    onChange(null, undefined);
    const input = document.getElementById("anexo-input") as HTMLInputElement;
    if (input) input.value = "";
  };

  return (
    <div>
      {podeAnexar && (
        <div className="mb-3">
          <label htmlFor="anexo-input" className="form-label fw-semibold">
            Anexar justificativa (PDF)
          </label>
          <input
            id="anexo-input"
            type="file"
            accept="application/pdf"
            className="form-control form-control-sm"
            onChange={handleFileChange}
          />
        </div>
      )}

      {possuiAnexo && (
        <div className="alert alert-secondary py-2 d-flex align-items-center justify-content-between">
          <div>
            <strong>Arquivo:</strong>{" "}
            <button
              type="button"
              className="btn btn-link btn-sm text-decoration-underline p-0"
              disabled={baixando}
              onClick={() => void abrirPDF()}
            >
              {nomeArquivo || "Anexo.pdf"}
            </button>
          </div>
          {podeAnexar && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm ms-2"
              onClick={handleRemove}
            >
              <i className="bi bi-trash"></i> Remover
            </button>
          )}
        </div>
      )}
    </div>
  );
};


